export default function useFooterLinks() {
    return [
        { url: '/terms', label: 'Terms of Service' },
        { url: '/community-guidelines', label: 'Community Guidelines' },
        { url: '/privacy', label: 'Privacy Policy' },
        { url: '/dmca', label: 'Copyright' },
    ]
}
